import { useState } from 'react'
import { Input } from './ui/input'
import { Button } from './ui/button'
import { Badge } from './ui/badge'
import { Search, Filter, X } from 'lucide-react'

const SearchFilter = ({ onSearch, onFilter, categories = [] }) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedCategory, setSelectedCategory] = useState('')
  const [isFilterOpen, setIsFilterOpen] = useState(false)

  const handleSearch = (value) => {
    setSearchTerm(value)
    onSearch(value)
  }

  const handleCategoryFilter = (category) => {
    const newCategory = selectedCategory === category ? '' : category
    setSelectedCategory(newCategory)
    onFilter(newCategory)
  }

  const clearFilters = () => {
    setSearchTerm('')
    setSelectedCategory('')
    onSearch('')
    onFilter('')
  }

  const hasActiveFilters = searchTerm || selectedCategory

  return (
    <div className="space-y-4">
      {/* Search Bar */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
        <Input
          type="text"
          placeholder="Duyurularda ara..."
          value={searchTerm}
          onChange={(e) => handleSearch(e.target.value)}
          className="pl-10 pr-4"
        />
      </div>

      {/* Filter Controls */}
      <div className="flex items-center justify-between">
        <Button
          variant="outline"
          size="sm"
          onClick={() => setIsFilterOpen(!isFilterOpen)}
          className="flex items-center gap-2"
        >
          <Filter size={16} />
          Filtrele
          {hasActiveFilters && (
            <Badge variant="secondary" className="ml-1 px-1 py-0 text-xs">
              {(searchTerm ? 1 : 0) + (selectedCategory ? 1 : 0)}
            </Badge>
          )}
        </Button>

        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={clearFilters}
            className="text-gray-600 hover:text-gray-800"
          >
            <X size={16} className="mr-1" />
            Temizle
          </Button>
        )}
      </div>

      {/* Category Filters */}
      {isFilterOpen && (
        <div className="bg-gray-50 rounded-lg p-4 space-y-3">
          <h4 className="font-medium text-gray-900">Kategoriler</h4>
          <div className="flex flex-wrap gap-2">
            {categories.map((category) => (
              <Badge
                key={category}
                variant={selectedCategory === category ? "default" : "outline"}
                className="cursor-pointer hover:bg-gray-200 transition-colors"
                onClick={() => handleCategoryFilter(category)}
              >
                {category}
              </Badge>
            ))}
          </div>
        </div>
      )}

      {/* Active Filters Display */}
      {hasActiveFilters && (
        <div className="flex flex-wrap gap-2">
          {searchTerm && (
            <Badge variant="secondary" className="flex items-center gap-1">
              Arama: "{searchTerm}"
              <X 
                size={14} 
                className="cursor-pointer hover:text-gray-700" 
                onClick={() => handleSearch('')}
              />
            </Badge>
          )}
          {selectedCategory && (
            <Badge variant="secondary" className="flex items-center gap-1">
              Kategori: {selectedCategory}
              <X 
                size={14} 
                className="cursor-pointer hover:text-gray-700" 
                onClick={() => handleCategoryFilter(selectedCategory)}
              />
            </Badge>
          )}
        </div>
      )}
    </div>
  )
}

export default SearchFilter
